export const SpacesApi = Symbol('SpacesApi');
